import React, {useState, useContext, useEffect} from 'react';
import {Row, Col, Button} from 'antd';
import {useRouter} from 'next/router'

import { pushRouteLogin } from '../auth/LoginRouting';
import {callApi} from '../../helpers/Api';
import NoStretchDiv from '../../helpers/NoStretchDiv';
import UserContext from '../../context/UserContext';

const AdultCheck = (props) => {
    const {loggedInUser, refreshContext} = useContext(UserContext);
    const [isAdult, setIsAdult] = useState(loggedInUser?.is_adult);
    const router = useRouter();

    useEffect(() => {
        if(loggedInUser)
            setIsAdult(loggedInUser.is_adult)
    }, [loggedInUser])

    return (
        !props.is_adult_content || isAdult ? (
            props.children
        ) : (
            loggedInUser ? (
                <NoStretchDiv>
                    <div className="center-form">
                        <h1>You must be at least 18 years old to view this.</h1>
                        <h3>Are you at least 18 years old?</h3>
                        <Row gutter={16}>
                            <Col className="gutter-row" span={12}>
                                <Button className="medium-darkable-button fable-button-inverse" size='large' block style={{
                                    marginBottom: '12px',
                                }}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        router.push('/')
                                    }}
                                >
                                    No
                                </Button>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Button className="medium-darkable-button fable-button" size='large' block style={{marginBottom: '12px'}}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        callApi('/api/own/user_account',{
                                            method: 'PUT',
                                            body: JSON.stringify({
                                                is_adult: true,
                                            })
                                        })
                                        .then(()=>{
                                            setIsAdult(true);
                                            refreshContext();
                                        });
                                    }}
                                >
                                    Yes
                                </Button>
                            </Col>
                        </Row>
                        <small>
                            Use of this site constitutes acceptance of our <a href="/policies/user-agreement" target="_blank">User Aggreement </a> 
                            and <a href="/policies/privacy-policy" target="_blank">Privacy Policy </a>. ©2020 fablement inc. All rights reserved.
                        </small>
                    </div>
                </NoStretchDiv>
            ) : (
                <NoStretchDiv>
                    <div className="center-form">
                        <h1>You must be logged in to view this content.</h1>
                        <h2>Log in to confirm your age.</h2>
                        <Button className="medium-darkable-button fable-button-inverse" size='large' block style={{marginBottom: '12px'}}
                            onClick={(e) => {
                                e.preventDefault();
                                pushRouteLogin(router);
                            }}
                        >
                            log in
                        </Button>
                        <small>
                            Use of this site constitutes acceptance of our <a href="/policies/user-agreement" target="_blank">User Aggreement </a> 
                            and <a href="/policies/privacy-policy" target="_blank">Privacy Policy </a>. ©2020 fablement inc. All rights reserved.
                        </small>
                    </div>
                </NoStretchDiv>
            )
        )
    )
}

export default AdultCheck;